import React, { useState } from "react";

import { Box, Flex, Link, Text } from "@chakra-ui/react";

import { Link as ReactLink } from "react-router-dom";

import FiltersSA from "../../components/FiltersSA";
import TableSA from "../../components/TableSA";
import { telefone as telMask } from "../../utils/masks";
import { servicoAcolhimentoFunc } from "../../../helpers/Funcionalidades";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAuthProvider } from "../../../Context/AuthProvider";

const ServicosAcolhimento = () => {
  document.title = "MCA - Serviços de Acolhimento";

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { roleKeycloack } = useAuthProvider();
  const columns = [
    {
      Header: "Nome",
      accessor: "nomeFantasia",
      Cell: (props) => {
        const id = props.row.original.id;
        return (
          <>
            {roleKeycloack &&
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
              <Link
                wordBreak={"break-all"}
                title={props.value}
                as={ReactLink}
                to={"/servico-acolhimento/" + id}
              >
                <Text minWidth="250px">{props.value}</Text>
              </Link>
            ) : (
              <Text minWidth="250px">{props.value}</Text>
            )}
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      sortType: (rowA, rowB, id, desc) => {
        const statusA =
          rowA.original.desativado === "S"
            ? "Desativado"
            : rowA.original.suspenso === "S"
            ? "Suspenso"
            : "Ativo";
        const statusB =
          rowB.original.desativado === "S"
            ? "Desativado"
            : rowB.original.suspenso === "S"
            ? "Suspenso"
            : "Ativo";
        return statusA.localeCompare(statusB, "pt-BR");
      },
      Cell: (props) => {
        return (
          <Text>
            {props.row.original.desativado === "S"
              ? "Desativado"
              : props.row.original.suspenso === "S"
              ? "Suspenso"
              : "Ativo"}
          </Text>
        );
      },
    },
    {
      Header: "Telefone",
      accessor: "telefones",
      Cell: (props) => {
        const tels = props.value;

        if (!tels) {
          return <span>{"Não possui telefone"}</span>;
        }

        return tels?.map((telefone, index) => {
          return (
            <React.Fragment key={index}>
              <span style={{ whiteSpace: "nowrap" }}>
                {telMask(telefone.telefone)}
              </span>
              {tels.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
    {
      Header: "Endereço",
      accessor: "endereco",
      Cell: (props) => {
        return <Text minWidth="300px">{props.value}</Text>;
      },
    },
  ];

  return (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <FiltersSA
        setData={setData}
        setLoading={setLoading}
        entidade="servico-acolhimento"
        roleKeycloack={roleKeycloack}
      />
      {!loading ? (
        <>
          {!!data && (
            <TableSA
              data={data}
              columns={columns}
              loading={loading}
              entidade="servico-acolhimento"
              roleKeycloack={roleKeycloack}
            />
          )}
        </>
      ) : (
        <Box mt={4}>
          <LoadingSpinner />
        </Box>
      )}
    </Flex>
  );
};

export default ServicosAcolhimento;
